import { create } from "zustand";

/**
 * Payment QRs waiting to be shown in the dialog (2026-10-22), one at a time, oldest first. Kept in a store, not in the
 * navbar's state, because the navbar is mounted again on every page change and a QR must not vanish with it.
 */
export const useQrQueue = create((set) => ({
  queue: [],
  push: (item) =>
    set((s) => (!item || !item.policyId || s.queue.some((q) => q.policyId === item.policyId) ? s : { queue: [...s.queue, item] })),
  drop: (policyId) => set((s) => ({ queue: s.queue.filter((q) => q.policyId !== policyId) })),
  clear: () => set({ queue: [] }),
}));
